import { FC } from 'react';

import { AppDashboard } from '@shared/types/app';

import { useAnalytics } from '@hooks/useAnalytics';
import { useDynamicAction } from '@hooks/useDynamicAction';

import { useRouter } from '@router/index';

import Card from '@components/layout/Card/Card';
import { HorizontalScroll } from '@components/layout/HorizontalScroll/HorizontalScroll';
import { Skeleton } from '@components/layout/Skeleton/Skeleton';
import { TitleToolbar } from '@components/layout/TitleToolbar/TitleToolbar';

import { KingOfDragBanner } from '@screens/entertainer/DragKingCommunityScreen/KingOfDragBanner';

import { SharedDashboardSectionProps } from '../DashboardScreen.types';

const SuggestedActionItem: FC<{
  action: AppDashboard['secondaryTiles']['suggestedActions'][number];
  onOpenSupport: () => void;
}> = ({ action, onOpenSupport }) => {
  const { track } = useAnalytics();
  const { handleDynamicAction } = useDynamicAction();

  return (
    <div key={action.title} className="h-100" style={{ width: 120 }}>
      <Card
        indicator={action.indicatorCount}
        className="h-100"
        onClick={() => {
          track('Suggested Action Clicked', action);

          if (action.to === 'OpenSupportModal') {
            onOpenSupport();
            return;
          }

          handleDynamicAction(action, { state: { back: '/', forceBack: true } });
        }}
      >
        <div className="p-2">
          <div className="text-align-center">
            <img
              src={action.imgUrl}
              alt={action.title}
              style={{ width: 40, height: 40, objectFit: 'contain' }}
            />
          </div>
          <div>
            <div className="text-align-center" style={{ fontSize: '.9rem' }}>
              <strong>{action.title}</strong>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export const SuggestedActions: FC<SharedDashboardSectionProps & { onOpenSupport: () => void }> = ({
  isAppDashboardReady,
  appDashboard,
  onOpenSupport,
}) => {
  if (!isAppDashboardReady) {
    return (
      <>
        <div>
          <div className="mb-2">
            <Skeleton height={22} />
          </div>
          <div className="mb-3">
            <Skeleton height={116} />
          </div>
        </div>
      </>
    );
  }

  if (!appDashboard?.secondaryTiles) {
    return <></>;
  }

  const { title, suggestedActions } = appDashboard?.secondaryTiles;

  return (
    <>
      <TitleToolbar text={title} size="sm" className="mb-1" />
      <HorizontalScroll
        items={[
          <div className="d-flex gap-2 pt-2 pe-4">
            {suggestedActions.map((action) => (
              <SuggestedActionItem
                key={action.title}
                action={action}
                onOpenSupport={onOpenSupport}
              />
            ))}
          </div>,
        ]}
      />
      <div className="mt-2">
        <KingOfDragBanner context="Entertainer Dashboard" />
      </div>
    </>
  );
};
